<div class="confirm-dialog" role="alertdialog" aria-live="assertive">
  @if (title()) {
    <h2 class="confirm-dialog__title confirmation-dialog-title">{{ title() }}</h2>
  }
  <div class="confirm-dialog__message confirmation-dialog-body">{{ message() }}</div>
  <div class="confirm-dialog__actions">
    @if (!hideCancelButton()) {
      <button
        id="confirmDialogCancelButton"
        type="button"
        class="btn btn-white"
        (click)="onCancel()"
        >
        {{ cancelLabel() }}
      </button>
    }
    <button
      id="confirmDialogConfirmButton"
      type="button"
      [ngClass]="danger() ? 'btn btn-danger' : 'btn btn-primary'"
      (click)="onConfirm()"
      >
      {{ confirmLabel() }}
    </button>
  </div>
</div>
